import { EmployeeSurveySTO } from "../../models/employee-survey/employee-survey-sto";
import { EmployeeSurveyDTO } from "../../models/employee-survey/employee-survey-dto";
import { BaseApiService } from "../base";

export class EmployeeSurveysApiService extends BaseApiService<EmployeeSurveyDTO, EmployeeSurveySTO> {
  constructor() {
    super({
      servicePath: "/EmployeeSurvey",
      loadItemsPath: "/GetEmployeeSurvey",
      saveItemsPath: "/SaveEmployeeSurvey",
    });
  }
}
